import React from "react";
import { AiIcon, Button } from "@sscs/ui";
import styles from "./aiButton.module.scss";

type AiGenerateProps = {
  isAiEnabled: boolean;
  label?: string;
  size?: React.ComponentProps<typeof Button>["size"];
  isInline?: boolean;
  className?: string;
  onClick: () => void;
};

const AiButton = ({
  isAiEnabled,
  label = "Generate",
  size,
  isInline = false,
  className,
  onClick,
}: AiGenerateProps): React.JSX.Element => {
  return (
    <Button
      color="nitro"
      size={size}
      isInline={isInline}
      startIcon={
        <AiIcon
          className={
            isInline || size === "small"
              ? styles["ai-icon-small"]
              : styles["ai-icon"]
          }
        />
      }
      onClick={onClick}
      disabled={!isAiEnabled}
      tooltipTitle={
        isAiEnabled
          ? undefined
          : "Ask your organization admin to enable this AI feature."
      }
      className={className}
    >
      {label}
    </Button>
  );
};

export default AiButton;
